import { createFileRoute, notFound } from '@tanstack/react-router';

import { getContent, getPage } from '@/lib/content-registry';
import { seoHead, notFoundHead } from '@/lib/seo';
import { ContentBlock } from '@/blocks/control-content';

export const Route = createFileRoute('/trophies/$slug')({
  loader: ({ params }) => {
    const page = getPage('/trophies/' + params.slug);
    if (!page || !getContent(page.url)) throw notFound();
    return { path: page.url };
  },
  head: ({ loaderData }) =>
    loaderData ? seoHead(getPage(loaderData.path)!) : notFoundHead(),
  component: () => <ContentBlock page={getPage(Route.useLoaderData().path)!} />,
});
